import actionTypes from './actionTypes'
import config from '../../../config/config'
import { checkLoggedIn } from '../../../routes/Login/actions'
import { getStorageInfo } from '../../../routes/ManagePlans/actions'
import { isSentry } from '../../../lib'

const {
  REQUEST_USERDATA,
  RECEIVE_USERDATA,
  REQUEST_TOKENVALIDITY,
  RECEIVE_TOKENVALIDITY,
  USER_VALIDITY,
  SERVER_ERROR_OCURED,
  LOG_OUT,
  SHOULD_REDIRECT,
  SHOULD_REDIRECT_LOGIN,
  SEMINAR_UPGRADE_MODAL
} = actionTypes

export function receiveUserdata (user) {
  return {
    type: RECEIVE_USERDATA,
    user
  }
}

export function newSeminarUpgradeModal (bool) {
  return {
    type: SEMINAR_UPGRADE_MODAL,
    open: bool
  }
}

export function logoutRequestResult (bool) {
  return {
    type: LOG_OUT,
    logoutSuccess: bool
  }
}

export function shouldRedirectUser (bool) {
  return {
    type: SHOULD_REDIRECT,
    shouldRedirect: bool
  }
}

export function shouldRedirectUserToLogin (bool) {
  return {
    type: SHOULD_REDIRECT_LOGIN,
    redirectToLogin: bool
  }
}

function hasErrored (bool) {
  return {
    type: SERVER_ERROR_OCURED,
    hasErrored: bool
  }
}

export function setUserValidity (bool) {
  return {
    type: USER_VALIDITY,
    userExists: bool
  }
}

export function returnUserIfUserExists (token) {
  return function (dispatch) {
    dispatch({type: REQUEST_USERDATA})
    return fetch(`${config.URI}/api/v1/current_user`, {
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch(receiveUserdata(res.data.current_user))
          dispatch(getStorageInfo(token))
        } else if (res.errors) {
          console.error('token not valid')
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}

export function checkValidity (token) {
  return function (dispatch) {
    dispatch({type: REQUEST_USERDATA})
    dispatch({type: REQUEST_TOKENVALIDITY})
    return fetch(`${config.URI}/api/v1/current_user`, {
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        dispatch({type: RECEIVE_TOKENVALIDITY})
        return res
      })
  }
}

export function checkTokenOnPathChange (token) {
  return function (dispatch) {
    return fetch(`${config.URI}/api/v1/current_user`, {
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        return res
      })
  }
}

export function logoutUser (token) {
  return function (dispatch) {
    dispatch({type: REQUEST_USERDATA})
    return fetch(`${config.URI}/api/v1/logout`, {
      method: 'DELETE',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch(shouldRedirectUserToLogin(true))
          dispatch(shouldRedirectUser(false))
          dispatch(logoutRequestResult(true))
          dispatch(checkLoggedIn(false))
        } else {
          dispatch(shouldRedirectUser(true))
          dispatch(shouldRedirectUserToLogin(false))
          dispatch(checkLoggedIn(true))
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/layouts/LoggedIn/actions/index.js